<template>
	<div class="itv-datepicker__trigger-wrap">
		<button
			class="itv-datepicker__trigger"
			:class="{ active: datepickerVisible, hasValue: value }"
			@click.prevent="showModal"
		>
			<span>{{ placeholder }}</span>
		</button>
		<div v-if="value" class="itv-datepicker__clear">
			<btn-clear @click-event="clearDate" />
		</div>
	</div>
	<Transition>
		<modal-default v-if="datepickerVisible" @hide-modal="hideModal">
			<template #header>
				{{ placeholder }}
			</template>
			<template #content>
				<VueDatePicker
					v-model="value"
					locale="ru"
					:start-date="startDate"
					:min-date="minDate"
					:max-date="maxDate"
					:year-range="[1960, 2010]"
					inline
					:enable-time-picker="false"
					:month-change-on-scroll="false"
					:name="name"
					@date-update="activeBtn = true"
					ref="datepicker"
				>
					<template #action-buttons>
						<div class="itv-datepicker__btn">
							<primary-button
								:content="cancelBtn"
								@click-event="clearDate"
								:class="{ disabled: !activeBtn }"
							/>
						</div>
						<div class="itv-datepicker__btn">
							<primary-button
								:content="confirmBtn"
								@click-event="selectDate"
								:class="{ disabled: !activeBtn }"
							/>
						</div>
					</template>
				</VueDatePicker>
			</template>
		</modal-default>
	</Transition>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker7'
import '@vuepic/vue-datepicker7/dist/main.css'

import ModalDefault from './ModalDefault'
import PrimaryButton from './PrimaryButton'
import BtnClear from './BtnClear'

export default {
	components: {
		VueDatePicker,
		ModalDefault,
		PrimaryButton,
		BtnClear,
	},
	props: {
		minDate: {
			type: String,
			default: '',
		},
		maxDate: {
			type: String,
			default: '',
		},
		startDate: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: 'date',
		},
	},
	data() {
		return {
			activeBtn: false,
			datepickerVisible: false,
			value: null,
			placeholder: 'Дата рождения',
			confirmBtn: {
				btnColorType: 'green',
				text: 'Применить',
			},
			cancelBtn: {
				btnColorType: 'transparent',
				text: 'Сбросить',
			},
		}
	},
	methods: {
		clearDate() {
			this.activeBtn = false
			if (this.$refs.datepicker) {
				this.$refs.datepicker.clearValue()
			} else {
				this.value = null
			}

			this.placeholder = 'Дата рождения'
			this.$emit('change-date', this.value, null)
			this.hideModal()
		},
		selectDate() {
			this.$refs.datepicker.selectDate()

			this.placeholder = this.formatDate(this.value)
			this.$emit('change-date', this.value, this.placeholder)
			this.hideModal()
		},

		formatDate(date, monthNumeric = false) {
			let monthFormat = 'long'
			if (monthNumeric) {
				monthFormat = 'numeric'
			}
			const options = {
				year: 'numeric',
				month: monthFormat,
				day: 'numeric',
			}

			return date.toLocaleString('ru', options)
		},

		hideModal() {
			this.datepickerVisible = false
		},
		showModal() {
			this.datepickerVisible = true
		},
	},
}
</script>
